import { render, staticRenderFns } from "./stadium_new.vue?vue&type=template&id=3b9a049c&"
import script from "./stadium_new.vue?vue&type=script&lang=ts&"
export * from "./stadium_new.vue?vue&type=script&lang=ts&"
import style0 from "./stadium_new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports